import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { Actions, ofType, createEffect } from '@ngrx/effects';

import { ThreadViewActionTypes } from '../actions/thread-view.actions';
import { StoreQuerierService } from '../../services/store-querier.service';

import { Thread } from '../../tamalelibs/models/thread.model';
import { EntryService } from '../../tamalelibs/services/entry.service';
import { ThreadService } from '../../tamalelibs/services/thread.service';

@Injectable()
export class ThreadViewEffects {
    constructor(
        private _actions$: Actions,
        private _entryService: EntryService,
        private _storeQuerier: StoreQuerierService,
        private _threadService: ThreadService
    ) { }

    getThreadEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(ThreadViewActionTypes.GET_THREAD),
        map((action: any) => action.payload),
        switchMap((payload: string) => {
            return this._threadService.getThreadById(payload);
        }),
        map(response => {
            return Thread.parse(response);
        }),
        switchMap((thread: Thread) => {
            const observables$ = [];
            thread.notes.forEach(note => {
                observables$.push(this._entryService.getNoteBodyById(note.id));
            });
            return forkJoin(observables$).pipe(
                map(responses => {
                    const currentUser = this._storeQuerier.getCurrentUser();
                    thread.notes.forEach((note, index) => {
                        note.body = this._entryService.appendUserIdToImageLinksInNoteBody(responses[index], currentUser.id);
                    });
                    return ({
                        type: ThreadViewActionTypes.GET_THREAD_SUCCESS,
                        payload: thread
                    });
                })
            );
        }),
        catchError(err => {
            return of({
                type: ThreadViewActionTypes.GET_THREAD_FAILED,
                payload: err.message
            });
        })
    ));

    getThreadSideSheetEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(ThreadViewActionTypes.GET_THREAD_SIDESHEET),
        map((action: any) => action.payload),
        switchMap((payload: string) => {
            return this._threadService.getThreadById(payload);
        }),
        map(response => {
            return Thread.parse(response);
        }),
        switchMap((thread: Thread) => {
            const observables$ = [];
            thread.notes.forEach(note => {
                observables$.push(this._entryService.getNoteBodyById(note.id));
            });
            return forkJoin(observables$).pipe(
                map(responses => {
                    const currentUser = this._storeQuerier.getCurrentUser();
                    thread.notes.forEach((note, index) => {
                        note.body = this._entryService.appendUserIdToImageLinksInNoteBody(responses[index], currentUser.id);
                    });
                    return ({
                        type: ThreadViewActionTypes.GET_THREAD_SIDESHEET_SUCCESS,
                        payload: thread
                    });
                })
            );
        }),
        catchError(err => {
            return of({
                type: ThreadViewActionTypes.GET_THREAD_SIDESHEET_FAILED,
                payload: err.message
            });
        })
    ));
}
